import { render } from "./RfqsCreate.vue?vue&type=template&id=b4f84a38"
import script from "./RfqsCreate.vue?vue&type=script&lang=js"
export * from "./RfqsCreate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__